import * as React from 'react';
import FormField from '../../FormElements/Field';
import SubmitButton from '../../FormElements/SubmitButton';
import { useCourierEmailGenerateForm } from './useCourierEmailGenerateForm';
import { useForm } from 'react-hook-form';
import { Company } from "../../../Model/Company";

export const CourierEmailGenerateForm = () => {
  const {register, reset, handleSubmit} = useForm<
    Partial<Company>
  >();
  const {
    onSubmit,
    currentCompany,
    onClose,
    inProgress,
    copyToClipboard
  } = useCourierEmailGenerateForm(register, reset);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormField name="email" label="Email cím">
          <input
            type="text"
            id="email"
            className="form-control"
            value={currentCompany?.courierEmail}
            disabled
          />
          {(currentCompany?.courierEmail) && (
            <div className="text-center">
              <button
                onClick={() => copyToClipboard(currentCompany?.courierEmail)}
                type="button"
                className="btn btn-outline-secondary mt-2"
              >
                Másolás
              </button>
            </div>
          )}
        </FormField>
        <div>
          <p className="alert alert-primary mt-2">
            Egyedi email cím generálás, amelyet a futárszolgálatoknak lehet megadni a csatolmányok átvételéhez.
          </p>
        </div>
        <div className="modal-footer mt-lg-4 d-flex justify-content-around">
          <button
            onClick={onClose}
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Mégse
          </button>
          <SubmitButton text={'Generálás'} className={'btn btn-primary'} inProgress={inProgress} disabled={inProgress}/>
        </div>
      </form>
    </div>
  );
};
